import { Env, Profile } from '@cca/util';

declare global {
  interface Window {
    env: any;
  }
}
type EnvType = {
  REACT_APP_CCA_PROFILE: Profile;
  REACT_APP_CCA_ENV: Env;
};

export const env: EnvType =
  typeof window !== 'undefined' ? window.env : process.env;
